/**
 * Curried version of `record[key]`. Is explicit about the return type
 * potentially being `undefined`.
 * @param object The object to index.
 * @param key The key to index with.
 * @returns The value at `key` or `undefined`.
 */
export const toPartialFunction =
    <TKey extends string | number | symbol, TValue>(record: Record<TKey, TValue>) =>
    (key: TKey): TValue | undefined =>
        record[key];
